import { Deserializable } from '../protocols/deserializable';
import { MemberSubmissionTypeEnum } from '../users/enum/member-submission-type-enum';

export class MemberSubmissionType implements Deserializable {
  public id!: MemberSubmissionTypeEnum;
  public name!: string;
  public idSuffix!: string;
  public effort!: number;
  public daysBeforeOverdue!: number;

  onDeserialize() {}
}
